export default __webpack_public_path__ + "static/media/icon-cashback-earned.3c06aa4a.svg";